import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

const STATUS_CLASS: Record<string, string> = {
  SUCCESS: 'bg-green-400 text-black',
  PARTIAL_SUCCESS: 'bg-yellow-300 text-black',
  FAILED: 'bg-red-500 text-white',
  IN_PROGRESS: 'bg-blue-200 text-black',
  PENDING: 'bg-gray-200 text-black',
}

export const formatExecutionTime = (ms?: number) =>
  ms ? `${(ms / 1000).toFixed(1)}s` : '-'

export const GenericLogStatusBadge = ({ status }: { status?: string }) =>
  status ? (
    <span
      className={`rounded-lg px-2 py-1 text-sm ${
        STATUS_CLASS[status] ?? 'bg-gray-200 text-black'
      }`}
    >
      {status}
    </span>
  ) : (
    <span>-</span>
  )

type GetColumnsParams = {
  page: number
  onView: (params: ICellRendererParams) => void
}

export const getColumns = ({ page, onView }: GetColumnsParams) =>
  [
    {
      headerName: '#',
      field: '_id',
      maxWidth: 80,
      valueFormatter: (params: ValueFormatterParams) =>
        (params.node?.rowIndex as number) + 1 + page,
    },
    {
      headerName: 'Module',
      field: 'module',
      minWidth: 130,
    },
    {
      headerName: 'Service',
      field: 'service',
      minWidth: 220,
    },
    {
      headerName: 'Action',
      field: 'action',
      minWidth: 180,
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 160,
      cellRenderer: (params: ICellRendererParams) => (
        <GenericLogStatusBadge status={params.value} />
      ),
    },
    {
      headerName: 'Requested By',
      field: 'requestedBy.name',
      minWidth: 150,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Execution Time',
      field: 'executionTimeMs',
      minWidth: 140,
      valueFormatter: (params: ValueFormatterParams) =>
        formatExecutionTime(params.value),
    },
    {
      headerName: 'Error',
      field: 'error.message',
      minWidth: 220,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Created At',
      field: 'createdAt',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? formatDate(params.value, { includeTime: true }) : '-',
    },
    {
      headerName: 'Details',
      field: '_id',
      maxWidth: 100,
      sortable: false,
      pinned: 'right',
      cellRenderer: (params: ICellRendererParams) => (
        <button
          onClick={() => onView(params)}
          className="rounded-md bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600
            transition-colors hover:bg-gray-200 hover:text-gray-800"
        >
          View
        </button>
      ),
    },
  ] as ColDef[]
